function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M49 196h97c14 0 25-11 25-25V49h122v235h-94v58H49zm73-104v55H76zM0 355c0 20 16 36 37 36h162V284h114V142s28 1 28 0V37c0-21-16-37-36-37H146c-7 0-14 4-18 9L6 156c-4 4-6 9-6 15zm219-46h98c13 0 24-10 24-24V163h122v293H219zm74-103v55h-46zM171 468c0 21 16 37 36 37h268c21 0 37-16 37-37V150c0-20-16-36-37-36H317c-8 0-14 3-19 9L176 269l1 1c-4 4-6 9-6 15z"
})));